/**
 * Message types for communication with React Native webview
 */
const MESSAGE_TYPES = {
  AD_INFO: 'AD_INFO',
};

export default MESSAGE_TYPES;
